import * as yup from 'yup';

const LoginFormValidation = yup
  .object({
    login: yup.string().required('Please enter your email or username'),
    password: yup.string().required('Please enter your Password'),
  });

export default LoginFormValidation;
